import { useStore } from 'zustand';
import { persist } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';

import type { SurveySidebarBaseState } from './survey-sidebar.util';

const initialState = {
  baseIsCollapsed: false,
  baseIsContextCollapsed: false,
  contextOpenAccordions: [
    'technology-overview',
    'use-domain',
    'recommended-services',
    'task-recommendations',
    'mission-assessment',
  ] as string[],
};

export type SurveySidebarStore = {
  baseIsCollapsed: boolean;
  baseIsContextCollapsed: boolean;
  contextOpenAccordions: string[];

  // Actions
  reset: () => void;
  setBaseState: (params: SurveySidebarBaseState) => void;
  setContextOpenAccordions: (accordions: string[]) => void;
};

export const surveySidebarStore = createStore<SurveySidebarStore>()(
  persist(
    (set) => ({
      ...initialState,

      reset: () => set(initialState),
      setBaseState: (params) => set(params),
      setContextOpenAccordions: (accordions) => set({ contextOpenAccordions: accordions }),
    }),
    {
      migrate: (persistedState) => {
        const state = persistedState as Partial<{
          baseIsCollapsed: boolean;
          baseIsContextCollapsed: boolean;
          contextOpenAccordions: string[];
          isCollapsed: boolean;
          isContextCollapsed: boolean;
        }>;

        return {
          ...initialState,
          baseIsCollapsed: state.baseIsCollapsed ?? state.isCollapsed ?? initialState.baseIsCollapsed,
          baseIsContextCollapsed:
            state.baseIsContextCollapsed ?? state.isContextCollapsed ?? initialState.baseIsContextCollapsed,
          contextOpenAccordions: state.contextOpenAccordions ?? initialState.contextOpenAccordions,
        };
      },
      name: 'surveySidebarStore',
      version: 2,
    },
  ),
);

export const useSurveySidebarStore = (): SurveySidebarStore => useStore(surveySidebarStore);
